export default class FilterLinks {

  els = {
    filterLink: '[data-filter-link]',
    filterRange: '[data-js-filter-range]',
    linksContainer: '[data-js-filter-id]'
  }


  constructor () {
    this.nodeListWithRange = document.querySelectorAll(`${this.els.linksContainer}${this.els.filterRange} input`)

    this.init()
    this.bindEvents()
  }

  getRootContainer(link){
    return link.closest(this.els.linksContainer)
  }

  getCheckbox(link){
    return link.querySelector('input[type="checkbox"]')
  }

  getRangeData(link){
    return this.getRootContainer(link).range
  }

  getNodeList(link){
    return this.getRootContainer(link).linkList
  }

  getCurrentLinkState(link){
    return this.getCheckbox(link).checked
  }

  getActiveLinksCount(link){
    const rootContainer = this.getRootContainer(link);
    return rootContainer.activeLinks
  }

  getCurrentLinkIndex(link) {
    let currentIndex = '';
    const linkId = this.getCheckbox(link).id;
    const currentLink = [...this.getRootContainer(link).linkList].find((item, index) => {
      if (this.getCheckbox(item).id === linkId) {
        currentIndex = index
        return item
      }
    })

    return currentLink ? currentIndex : false
  }

  saveLinkList(link){
    if (!this.getRootContainer(link).linkList) {
      const rootContainer = this.getRootContainer(link);
      rootContainer.linkList = rootContainer.querySelectorAll(this.els.filterLink);
    }
  }

  saveDefaultActiveLink(link){
    if (!this.getRootContainer(link).activeLinks || this.getRootContainer(link).activeLinks < 0) {
      const rootContainer = this.getRootContainer(link);
      rootContainer.activeLinks = 0
    }
  }

  saveDefaultRange(link){
    if (!this.getRootContainer(link).range) {
      const rootContainer = this.getRootContainer(link);
      rootContainer.range = {
        min: 0,
        max: 0
      }
    }
  }

  setActiveLink(link, check){
    if (check === null){
      return
    }
    const rootContainer = this.getRootContainer(link);
    check ? rootContainer.activeLinks += 1 : rootContainer.activeLinks -= 1
  }

  comparePosition(link) {
    const rangeData = this.getRangeData(link)
    const currentIndex = this.getCurrentLinkIndex(link)

    if (currentIndex === rangeData.min && currentIndex === rangeData.max) {
      return {
        state: 'clearRange',
        index: null
      }
    }
    if (currentIndex < rangeData.min) {
      return {
        state: 'newMin',
        index: currentIndex
      }
    }
    if (currentIndex === rangeData.min) {
      return {
        state: 'newMin',
        index: currentIndex + 1
      }
    }
    if (currentIndex > rangeData.max) {
      return {
        state: 'newMax',
        index: currentIndex
      }
    }
    if (currentIndex === rangeData.max) {
      return {
        state: 'newMax',
        index: currentIndex - 1
      }
    }
  }

  setRangeData(link, stateData = false) {
    const compareResult = stateData ? stateData : this.comparePosition(link)
    const rootContainer = this.getRootContainer(link)
    switch (compareResult.state) {
      case 'newMin':
        rootContainer.range = {...rootContainer.range, min:compareResult.index}
        break;
      case 'newMax':
        rootContainer.range = {...rootContainer.range, max:compareResult.index}
        break;
      case 'newRange':
        rootContainer.range = {min:compareResult.index, max:compareResult.index}
        break;
      case 'clearRange':
        rootContainer.range = {min:0, max:0}
        break;
      default:
        break;
    }
  }

  setAllCheckboxInRange(link) {
    const rangeData = this.getRangeData(link);
    const currentNodeList = this.getNodeList(link);
    const uncheckedNodes = [...currentNodeList].slice(rangeData.min + 1, rangeData.max).filter(node=>{
      return !this.getCheckbox(node).checked
    })

    uncheckedNodes.forEach(node=> {
      this.toggleLink(node)
      this.getCheckbox(node).checked = true
      this.setActiveLink(node, true)
    })
  }

  resetDynamicRange(container) {
    container.activeLinks = 0
    container.range = {min:0, max:0}
  }

  dynamicRange(e) {
    let currTarget = e.target.closest(this.els.filterLink)
    // if all checkbox is uncheck
    if (this.getActiveLinksCount(currTarget) === 0) {
      this.toggleLink(currTarget)
      this.setActiveLink(currTarget, e.target.checked)
      this.setRangeData(currTarget, {state:'newRange', index: this.getCurrentLinkIndex(currTarget)})
      return false
    }

    // link is a min || max
    if (this.getCurrentLinkIndex(currTarget) === this.getRangeData(currTarget).min ||
      this.getCurrentLinkIndex(currTarget) === this.getRangeData(currTarget).max)
    {
      this.toggleLink(currTarget)
      this.setActiveLink(currTarget, e.target.checked)
      this.setRangeData(currTarget)
      return false
    }

    //link in a range
    if(this.getCurrentLinkIndex(currTarget) > this.getRangeData(currTarget).min &&
      this.getCurrentLinkIndex(currTarget) < this.getRangeData(currTarget).max) {
      e.target.checked = true
      return false
    }

    this.toggleLink(currTarget)
    this.setActiveLink(currTarget, e.target.checked)
    this.setRangeData(currTarget)
    this.setAllCheckboxInRange(currTarget)
  }


  toggleLink (link) {
    //добавляю проверку на radio, чтобы у radio групп убирать проставленные активности
    if (link.getAttribute("type") === "radio" && link.getAttribute("name")) {
      const formTarget = link.form || document.getElementById(link.getAttribute("form"));
      const radioEls = formTarget.querySelectorAll(`input[type="radio"][name="${link.getAttribute("name")}"]`);
      radioEls.forEach((el) => {
        el.closest(this.els.filterLink).classList.remove('filter__btn_selected')
      })
    }
    link.closest(this.els.filterLink).classList.toggle('filter__btn_selected')
  }

  init(){
    this.nodeListWithRange.forEach(container=> {
      const link = container.closest(this.els.filterLink);
      if (link) {
        this.saveLinkList(link)
        this.saveDefaultActiveLink(link)
        this.saveDefaultRange(link)
      }
    })
  }


  bindEvents () {
    this.nodeListWithRange.forEach(node => {
      node.addEventListener('click', (e) => this.dynamicRange(e))
    })

    document.querySelectorAll(`${this.els.linksContainer}:not(${this.els.filterRange}) ${this.els.filterLink} input`).forEach(node => {
      node.addEventListener('change', (e)=> {
        this.toggleLink(e.target)
      })
    })

    $(document).on('trigger::clear-filters-row', (e,container)=> this.resetDynamicRange(container))
  }
}

